import { obterParametrosDaURL } from "../../../../functions";
import { api } from "../../api";
import { ApiException } from "../../api-exception";

export interface ICabecalhoJuros {
  orcamento: number;
  loja: number;
  codCliente?: number;
  nomeCliente: string;
  valorFinal: number;
  juros: number;
  valorSemJuros: number;
  data?: string;
  codCondicaoPgto?: number;
  descricaoCondicaoPgto: string;
}

export interface INegociacaoJuros {
  nrParcela: number;
  codFormaPgto: number;
  descricaoFormaPagamento: string;
  valorFinal: number;
  juros: number;
  valorSemJuros: number;
  vencimento: string;
}

export interface IDetalhesJuros {
  cabecalho: ICabecalhoJuros;
  negociacao: INegociacaoJuros[];
}

export const ObterDetalhesDeJuros = async (
  documento: string,
  codLoja: number
): Promise<IDetalhesJuros> => {
  const { token } = obterParametrosDaURL();

  try {
    const { data } = await api.get<IDetalhesJuros>(`/obter-detalhes-de-juros`, {
      params: { documento, codLoja },
      headers: { token },
    });

    return data;
  } catch (erro) {
    throw new ApiException(
      erro,
      "Não foi possível obter os detalhes da solicitação de juros tipo gerência"
    );
  }
};